import styled from '@emotion/styled';
import {
  BREAKPOINTS,
  COLOR,
  FONT_SIZE,
  FONT_WEIGHT,
} from '@ordermentum/ui-constants';
import { FONT_FAMILY } from '@ordermentum/ui-static';
import { InfoBannerT } from './index.types';

export const SignInLabelContainer = styled('div')`
  display: flex;
  flex-direction: rows;
  justify-content: space-between;
  align-items: baseline;
`;

export const SignInText = styled('div')`
  font-family: ${FONT_FAMILY.FUTURO.HEADING};
  font-size: ${FONT_SIZE['2XL']};
  font-weight: ${FONT_WEIGHT.BOLD};

  @media screen and (max-width: ${BREAKPOINTS.MOBILE_MAX}) {
    font-size: ${FONT_SIZE.XL};
  }
`;

export const SignInSwitch = styled('div')`
  font-size: ${FONT_SIZE.BASE};
  font-weight: ${FONT_WEIGHT.NORMAL};

  button {
    font-size: ${FONT_SIZE.BASE};
    text-decoration: underline;
    display: inline-block;
    font-weight: ${FONT_WEIGHT.BOLD};
  }

  a {
    text-decoration: underline;
    font-weight: ${FONT_WEIGHT.BOLD};
    color: ${COLOR.ORANGE};
  }
`;

export const ErrorBannerWrapper = styled('div')`
  margin-top: 1rem;
`;

export const FormWrapper = styled('div')`
  margin-top: 1rem;
`;

export const FieldWrapper = styled('div')`
  margin-top: 1.25rem;

  :first-child {
    margin-top: 0;
  }
`;

export const AuthActionContainer = styled('div')`
  margin-top: 2.5rem;
`;

export const EmailLink = styled('a')`
  color: ${COLOR.PRIMARY};
`;

export const ForgottenPassword = styled('div')`
  text-align: center;
  margin-top: 1rem;

  a {
    font-weight: ${FONT_WEIGHT.NORMAL};
    color: ${COLOR.PRIMARY};
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const infoColorMap = {
  success: COLOR.GREEN_CEF2D4,
  error: COLOR.RED_FED8D8,
};

export const InfoBanner = styled('div')<{ type?: InfoBannerT }>`
  background: ${p => infoColorMap[p.type ?? 'success']};
  font-size: ${FONT_SIZE.SM};
  font-weight: ${FONT_WEIGHT.MEDIUM};
  padding: 0.5rem;
  margin-bottom: 1rem;
`;

export const PaymentSuccessBanner = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -2rem;
  padding-bottom: 1.5rem;

  & > h1 {
    font-family: ${FONT_FAMILY.FUTURO.HEADING};
    font-size: ${FONT_SIZE['4XL']};
    font-weight: ${FONT_WEIGHT.BOLD};
    margin: 0;
  }

  & > p {
    font-weight: ${FONT_WEIGHT.NORMAL};
    line-height: 1.5rem;
  }

  @media screen and (max-width: ${BREAKPOINTS.MOBILE_MAX}) {
    & > h1 {
      font-size: ${FONT_SIZE['2XL']};
    }
  }
`;
